import Card from "../../../../content/blocks/recommendation-card";
import * as React from 'react';
export default {
  Card,
  React
};